<template>
  <div class="leaderboard black-glass-strong" style="padding-bottom: 16px; position: relative; z-index: 1; border: 2px solid #fff; background: #fff;">

    <div class="lb-header">
      <div class="lb-header-left">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#00b4b4" stroke-width="1.5"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M2 19h20M3 9l4 4 5-7 5 7 4-4v10H3z" />
        </svg>
        <h2>FreeSpan™ Leaderboard</h2>
      </div>
      <a href="/freespan-opportunity-registration" class="submit-btn">
        Submit Opportunity <i class="material-icons">keyboard_arrow_right</i>
      </a>
    </div>

    <div v-if="!freespanData && !freespanData.length" class="loading" style="position: relative; height: 100px;">
      <AtomSpinner :animation-duration="1000" :size="60" color="#00b4b4" />
    </div>

    <div v-else>

<div style="padding:0 16px 0;">
  <div class="lb-rows" style="background: #4A5562; border-radius: 6px; padding: 16px;">
    
    <h3 style="color: #fff; margin: 0 0 12px 0;
    font-size: 18px;
    font-weight: 600;">Overall incoming</h3>



    <div v-if="freespanData && freespanData.length">
  
      <div
  v-for="(row, index) in freespanData"
  :key="index"
  class="lb-row"
  :class="{ first: index === 0 }"
>
  <div class="rank-num">{{ index + 1 }}</div>
  <div class="lb-info">
    <div class="entry-line" style="position: relative;">
      <p class="entry-name">
        <span class="name-line">
          <strong style="color: #fff;">{{ row.Salesperson }}</strong>
          <span class="entry-co">
            — {{ row['Salesperson Customer'] }}
          </span>
        </span>
      </p>
    </div>

    <div class="bar-wrap">
      <div
        class="bar"
        :style="{ width: barWidthIncoming(row.IncomingDollars) + '%' }"
      ></div>
    </div>
  </div>
  <span class="subs">{{ formatDollars(row.IncomingDollars) }}</span>
</div>
    </div>
  </div>
</div>
    </div>

    <a href="https://spacesaver.widen.net/view/pdf/gyct5alaqw/Info-Sheet---2026-FreeSpan-Sales-Competition.pdf?t.download=true&u=sphzbh" target="_blank" style="text-align: center; color: #00b4b4!important; margin: 16px; margin-top: 10px; margin-left: auto; margin-right: auto; display: block; font-size: 14px; margin-bottom: 0px;">
      Sales Competition Overview
    </a>  
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";

const VISIBLE_LIMIT = 2;

export default {
  name: 'FreespanLeaderboard',
  components: { AtomSpinner },

  data() {
    return {
      server: import.meta.env.VITE_APP_SERVER_URL,
      loading: true,
      overallStats: [],
      allSubmissions: [],
      tooltipVisible: {},
      data: null,
    };
  },
  props: {
    freespanData: {
      type: Array,
      default: () => []
    }
  },

  created() {
    // this.fetchLeaderboardNew()
    // this.fetchLeaderboard();
  },

  computed: {
    maxIncoming() {
      if (!this.freespanData?.length) return 1
      return Math.max(
        ...this.freespanData.map(r => Number(r.IncomingDollars) || 0),
        1
      )
    },
    slug() {
        const params = this.$route.params || {};
        return params.slug 
            || params.id 
            || this.$route.path.split('/').pop()   // gets last part of URL
            || this.$route.name 
            || '';
    },
    currentMonthName() {
      const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      return months[new Date().getMonth()];
    },
  },

  methods: {
    async fetchLeaderboardNew() {
      this.loading = true;
      try {
        const response = await axios.get(`https://news.spacesaver.com/api/freestyle?populate=*`);

        console.log("API response:", response.data.data);

        this.data = response.data.data;
        this.loading = false;
      } catch (err) {
        console.error("Failed to fetch data:", err);
      } finally {
        this.loading = false;
      }
    },

    barWidthIncoming(dollars) {
      const value = Number(dollars) || 0
      const max = Number(this.maxIncoming) || 1
      return Math.min(100, Math.round((value / max) * 100))
    },

    formatDollars(value) {
      return Number(value || 0).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
      })
    },
    


    async fetchLeaderboard() {
      try {
        const response = await axios.get(`${this.server}/api/v1/freespan-stats-new`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("USER")}` }
        });

        this.overallStats = response.data.overall_stats || [];
        this.allSubmissions = response.data.all_submissions || [];

        console.log(`Overall stats: ${this.overallStats.length} rows`);
        console.log(`All submissions: ${this.allSubmissions.length} rows`);
      } catch (err) {
        console.error("Failed to fetch data:", err);
      } finally {
        this.loading = false;
      }
    },

    barWidthPhase1(points) {
      const numPoints = Number(points) || 0;
      return Math.round((numPoints / this.maxPhase1) * 100);
    },

    truncateCompany(name) {
      if (!name) return '';
      return name.length > 22 ? name.substring(0, 22) + '...' : name;
    },

    getOrdinal(n) {
      if (n === 0) return '0th';

      const suffixes = ['th', 'st', 'nd', 'rd'];
      const lastTwoDigits = n % 100;

      // Special cases for 11th, 12th, 13th
      if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
        return n + 'th';
      }

      // Normal cases: 1st, 2nd, 3rd, 4th, ..., 21st, 22nd, 23rd, etc.
      return n + (suffixes[n % 10] || 'th');
    },

    // Filter submissions by month
    filterByDateRange(data, startMonth, endMonth) {
      if (!Array.isArray(data)) return [];

      return data.filter(item => {
        const dateStr = item.CreatedDate;
        if (!dateStr) return false;

        const match = String(dateStr).match(/^(\d{4})-(\d{2})/);
        if (!match) return false;

        const year = parseInt(match[1], 10);
        const month = parseInt(match[2], 10);

        return year === 2026 && month >= startMonth && month <= endMonth;
      });
    },

    // Group allSubmissions by SalesRep + AreaContractorName and count them
    getGroupedSubmissions(submissions) {
      const map = new Map();

      submissions.forEach(item => {
        const key = `${item.SalesRep}|${item.AreaContractorName}`;
        if (!map.has(key)) {
          map.set(key, {
            SalesRep: item.SalesRep,
            AreaContractorName: item.AreaContractorName,
            SubmissionCount: 0
          });
        }
        map.get(key).SubmissionCount += 1;
      });

      return Array.from(map.values());
    },

    getTop3Groups(leaderboard) {
      const places = [
        { key: 'firstPlace', rank: 1 },
        { key: 'secondPlace', rank: 2 },
        { key: 'thirdPlace', rank: 3 }
      ];

      return places
        .filter(({ key }) => leaderboard[key] && leaderboard[key].length > 0)
        .map(({ key, rank }) => {
          const entries = leaderboard[key];
          return {
            rank,
            SubmissionCount: entries[0]?.SubmissionCount || 0,
            visible: entries.slice(0, VISIBLE_LIMIT),
            hidden: entries.slice(VISIBLE_LIMIT)
          };
        });
    },

    truncateName(name) {
      if (!name) return '';
      const trimmed = name.trim();
      return trimmed.length > 8 ? trimmed.slice(0, 8) + '...' : trimmed;
    },

    formatCompanyName(name) {
      if (!name) return '';
      return name.toLowerCase()
        .split(/\s+/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },

    barWidthPhase1(count) {
      return Math.round((count / this.maxPhase1) * 100);
    },

    barWidthPhase2(count) {
      return Math.round((count / this.maxPhase2) * 100);
    },

    createLeaderboard(data) {
      if (!Array.isArray(data) || data.length === 0) {
        return { firstPlace: [], secondPlace: [], thirdPlace: [] };
      }

      const sorted = [...data].sort((a, b) => (b.SubmissionCount || 0) - (a.SubmissionCount || 0));
      const result = { firstPlace: [], secondPlace: [], thirdPlace: [] };
      let currentRank = 1;
      let i = 0;

      while (i < sorted.length && currentRank <= 3) {
        const currentCount = sorted[i].SubmissionCount || 0;
        const group = [];

        while (i < sorted.length && (sorted[i].SubmissionCount || 0) === currentCount) {
          group.push({
            SalesRep: sorted[i].SalesRep,
            AreaContractorName: sorted[i].AreaContractorName,
            SubmissionCount: sorted[i].SubmissionCount
          });
          i++;
        }

        if (currentRank === 1) result.firstPlace = group;
        else if (currentRank === 2) result.secondPlace = group;
        else if (currentRank === 3) result.thirdPlace = group;

        currentRank++;
      }
      return result;
    }
  }
};
</script>






<style scoped>
/* All your original styles + new top sections + no-data message */

.leaderboard {
  max-width: 1200px;
  margin: 20px 0;
  background: rgba(255,255,255,.5);
  border-radius: 8px;
  overflow: auto;
}

.lb-header {
  /* ... your existing header styles ... */
}

.loading {
  /* ... */
}

/* Top sections */
.overall-leaders,
.monthly-leader {
  padding: 0 16px;
  padding-top: 0;
  margin-bottom: 10px;
  border-radius: 8px;
}

.overall-leaders h3,
.monthly-leader h3 {
  margin: 0 0 12px 0;
  font-size: 18px;
  font-weight: 600;
  color: #111;
}

.overall-grid,
.monthly-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 12px;
}

.overall-item,
.monthly-item {
  /*
  display: flex;
  align-items: center;
  gap: 12px;
  */
  padding: 10px 12px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 13px;
}

.overall-rank,
.monthly-rank {
  font-weight: 700;
  color: #000;
  min-width: 28px;
  background: #eaeff2;
  font-size: 22px;
  text-align: center;
}

.overall-names,
.monthly-names {
  flex: 1;
  line-height: 1.4;
  padding: 5px 0;
  text-align: center;
}

.overall-co,
.monthly-co {
  color: #6c757d;
}

.overall-count,
.monthly-count {
  font-weight: 500;
  color: #00b4b4;
  white-space: nowrap;
}

.monthly-item {
  font-size: 12.5px;
}

/* Phase rows */
.lb-rows {
  
  display: flex;
  flex-direction: column;
  border-radius:12px;
  padding: 16px;
}

.no-data {
  padding: 20px;
  text-align: center;
  color: #6c757d;
  font-style: italic;
}


/* Rows */
.lb-rows {
  padding: 0 16px 16px;
  display: flex;
  flex-direction: column;
}

.lb-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, .4);
}

.lb-row:last-child {
  border-bottom: none;
}

/* Rank number */
.rank-num {
  font-size: 22px;
  font-weight: 700;
  color: #ccced1;
  width: 28px;
  text-align: center;
  flex-shrink: 0;
  line-height: 1;
}

/* Info column */
.lb-info {
  flex: 1;
  min-width: 0;
}

.entry-line {
  position: relative;
}

.entry-name {
  font-size: 13px;
  font-weight: 400;
  color: #111;
  margin: 0 0 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.entry-name strong {
  font-weight: 500;
}

.entry-co {
  font-weight: 400;
  color: #6c757d;
  color: rgba(255,255,255, 80%)!important;
}

/* "and N others" */
.others-label {
  color: #00b4b4;
  cursor: pointer;
  font-size: 13px;
}

.others-label:hover {
  text-decoration: underline;
}

/* Tooltip */
.others-tooltip {
  position: absolute;
  top: 22px;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.82);
  color: #fff;
  border-radius: 4px;
  padding: 8px 12px;
  min-width: 220px;
  pointer-events: none;
}

.tooltip-line {
  font-size: 12px;
  margin: 0 0 3px;
  white-space: nowrap;
  line-height: 1.4;
}

.tooltip-line:last-child {
  margin-bottom: 0;
}

/* Bar */
.bar-wrap {
  height: 4px;
  background: #f3f4f6;
  border-radius: 2px;
  overflow: hidden;
}

.bar {
  height: 4px;
  background: #00b4b4;
  border-radius: 2px;
  transition: width 0.4s ease;
}

/* Submission count */
.subs {
  font-size: 17px;
  font-weight: bold;
  color: #fff;
  flex-shrink: 0;
  white-space: nowrap;
}

.lb-row.first .subs {
  color: #fff;
  font-weight: 500;
}

/* Responsive */
@media (max-width: 560px) {
  .subs {
    display: none;
  }
}

/* Header */
.lb-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 16px;
}

.lb-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.lb-header-left h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 500;
  color: #111;
}

.submit-btn {
  font-size: 12px;
  color: #00b4b4;
  border: 1px solid #00b4b4;
  border-radius: 4px;
  padding: 5px 12px;
  display: flex;
  align-items: center;
  gap: 2px;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.25s ease;
  margin-bottom: 0;
}

.submit-btn:hover {
  background: #00b4b4;
  color: #fff;
}

/* Podium styles - Clean & Tall 1st Place */
.podium-grid {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 24px;
  margin: 20px 0;
  width: 100%;
}

.podium-place {
  text-align: center;
  background: #4A5562;
  border-radius: 6px;
  padding: 24px 20px 20px;
  flex: 1;
  min-width: 0;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  transition: all 0.25s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 260px;
  /* Base height for 2nd and 3rd */
}

.podium-place.first {
  transform: scale(1.08) translateY(-16px);
  /*border-color: #fcd34d;
  background: linear-gradient(to bottom, #fffbeb, #fffaf0);*/
  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.22);
  z-index: 1;
  min-height: 310px;
  /* Makes 1st place clearly taller */
  padding-top: 32px;
}

.podium-place:hover {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
}

.podium-place.first:hover {
  transform: scale(1.08) translateY(-20px);
}

/* Medal & Points */
.medal {
  font-size: 44px;
  /*margin-bottom: 12px;*/
}

.points {
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 10px;
}

.points.highlight {
  font-size: 34px;
  color: #fff;
}

/* Names */
.names {
  flex: 1;
  font-size: 14.5px;
  line-height: 1.55;
  margin-bottom: 12px;
}

.name-line {
  margin-bottom: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.co {
  color: rgba(255,255,255, 80%)!important;
}

/* "and X more" */
.others-label {
  color: #00b4b4;
  cursor: pointer;
  font-size: 13.5px;
  font-weight: 500;
}

.others-label:hover {
  text-decoration: underline;
}

/* Rank label */
.rank-label {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  margin-top: auto;
  padding-top: 6px;
  padding-bottom: 6px;
  border-radius: 4px;
  border-top: 1px solid #f1f5f9;
  background: #667684;
  text-align: center;
}

/* Improved tooltip for podium - same style as Phase 1 */
.podium-place .others-tooltip {
  top: 38px;
  /* Adjusted position for podium layout */
  left: 50%;
  transform: translateX(-50%);
  min-width: 260px;
  text-align: left;
}

.podium-place .entry-name {
  font-size: 14.5px;
  line-height: 1.55;
  margin: 0;
  text-align: center;
  color: #fff;
}

.podium-place .others-label {
  color: #00b4b4;
  cursor: pointer;
  font-weight: 500;
}

.podium-place .others-label:hover {
  text-decoration: underline;
}

.others-tooltip {
  position: absolute;
  top: 22px;
  left: 50%;
  /* Better centering */
  transform: translateX(-50%);
  z-index: 100;
  background: rgba(0, 0, 0, 0.82);
  color: #fff;
  border-radius: 6px;
  padding: 10px 14px;
  min-width: 240px;
  pointer-events: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

/* Make "and X more" not affect layout height */
.others-label.absolute {
  position: absolute;
  bottom: -20px;
  /* Position it nicely above the rank label */
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  z-index: 5;
}

/* Adjust names area to make space at the bottom */
.names {
  flex: 1;
  font-size: 14.5px;
  line-height: 1.55;
  margin-bottom: 32px;
  /* Extra space for the absolute "and X more" */
  position: relative;
}

.name-line {
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

/* Tooltip positioning - improved for podium */
.others-tooltip {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 6px;
  z-index: 100;
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  border-radius: 6px;
  padding: 10px 14px;
  min-width: 260px;
  pointer-events: none;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
}
.lb-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, .4);
}

.lb-row:last-child {
  border-bottom: none;
}

.rank-num {
  font-size: 26px;
  font-weight: 700;
  color: #ccced1;
  width: 36px;
  text-align: center;
  flex-shrink: 0;
}

.lb-info {
  flex: 1;
  min-width: 0;
}

.entry-name {
  font-size: 14px;
  margin: 0 0 8px 0;
  line-height: 1.45;
}

.name-line {
  display: inline;
  display: block;
}

.entry-co {
  color: #6c757d;
}

.others-label {
  color: #00b4b4;
  cursor: pointer;
  font-weight: 500;
}

.others-label:hover {
  text-decoration: underline;
}

.subs {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  min-width: 90px;
  text-align: right;
}

.bar-wrap {
  height: 6px;
  background: #f3f4f6;
  border-radius: 3px;
  overflow: hidden;
  margin-top: 4px;
}

.bar {
  height: 100%;
  background: #00b4b4;
  border-radius: 3px;
  transition: width 0.4s ease;
}
.monthly-names .entry-name {
  text-align: center;
}

.monthly-names .name-line {
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Phase 1 name fixes */
.lb-row .name-line {
  /*display: block; */          /* Ensures each person is on their own line */
  margin-bottom: 3px;
}

.lb-row .entry-name {
  margin-bottom: 8px;
  line-height: 1.4;
}
.db{
  display: block;
}

/* ################ */
.monthly-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
  margin-top: 16px;
}

.monthly-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  transition: all 0.2s ease;
}

.monthly-rank-badge {
  font-size: 18px;
  font-weight: 700;
  color: #64748b;
  margin-bottom: 0px;
}

.ordinal {
  font-size: 14px;
  font-weight: 500;
}

.points-big {
  font-size: 28px;
  font-weight: 700;
  color: #111;
  margin: 5px 0;
}

.points-big small {
  font-size: 14px;
  font-weight: 400;
  color: #6b7280;
}

.monthly-names {
  font-size: 14.5px;
  line-height: 1.6;
  text-align: center;
}

.name-line {
  margin-bottom: 6px;
}
/* Monthly Card Grid - Improved */
.monthly-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 18px;
  margin-top: 16px;
}

.monthly-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 24px 20px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  transition: all 0.25s ease;
  position: relative;
  min-height: 180px;
}

.monthly-card:hover {
  /*
  transform: translateY(-6px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
  */
}

.monthly-card.first {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  transform: translateY(-4px);
}

.monthly-card.first:hover {
  transform: translateY(-10px);
}

/* Rank Badge */
.monthly-rank-badge {
  font-size: 17px;
  font-weight: 700;
  color: #64748b;
  margin-bottom: 0px;
  letter-spacing: 0.5px;
}

.ordinal {
  font-size: 13px;
  font-weight: 500;
}

/* Points */
.points-big {
  font-size: 29px;
  font-weight: 700;
  color: #111;
  margin: 5px 0 5px 0;
}

.points-big small {
  font-size: 15px;
  font-weight: 400;
  color: #6b7280;
}

/* Names */
.monthly-names {
  font-size: 14.5px;
  line-height: 1.55;
  min-height: 60px;
}

.name-line {
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.co {
  color: #6b7280;
}

/* Others label */
.others-label {
  color: #00b4b4;
  cursor: pointer;
  font-size: 13.5px;
  font-weight: 500;
  display: inline-block;
  /*margin-top: 8px;*/
}

.others-label:hover {
  text-decoration: underline;
}
.db{
  display: block;
}
  .pixelsbg {
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23505a65'/%3E%3Cstop offset='1' stop-color='%23505a65' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233f474f'/%3E%3Cstop offset='1' stop-color='%233f474f' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23383e45'/%3E%3Cstop offset='1' stop-color='%23383e45' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%23474f58' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%23464f58' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%23464e57' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%23454e56' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23454d56' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%23444d55' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%23444c55' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%23434b54' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%23434b53' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23424a53' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23424a52' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23404850' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23404750' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%233f474f' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%233e454d' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%233e454c' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%233d444c' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%233d444b' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%233c434b' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%233c424a' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%233b4249' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%233b4149' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%233a4148' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%233a4047' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%23394047' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%23393f46' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%23383f46' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%23394047' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%233b4148' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%233c434a' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%233d444c' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%233f464e' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%2340474f' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23414951' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23434a53' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23444c55' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%23454d57' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%23474f58' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%2348515a' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%2349525c' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%234b545e' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%234c5560' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%234d5761' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%234f5963' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%23505a65' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%23515c67' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%23535d69' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%23545f6b' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2355616c' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2357626e' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%23586470' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%235a6672' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%235b6774' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%235c6976' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b78' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%235f6c7a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23616e7c' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%2362707d' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%2363717f' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23657381' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23667583' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23687685' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525b' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c555f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5660' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234d5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234e5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%234f5a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23505b65' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%23545f6a' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355606c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356616d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636e' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6773' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235c6976' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235d6a77' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%235f6d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23606e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23616f7c' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647280' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657382' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%23383e45' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='.5'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233c768a'/%3E%3Cstop offset='1' stop-color='%233c768a' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23305e6e'/%3E%3Cstop offset='1' stop-color='%23305e6e' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%231a8182'/%3E%3Cstop offset='1' stop-color='%231a8182' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%2346505a' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%2344515c' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%2343515d' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%2341525e' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23405260' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%233e5361' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%233d5462' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%233c5463' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%233a5565' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23395666' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23375767' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23365969' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23345a6a' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23335b6b' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23325d6c' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%23305e6e' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%232f606f' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%232d6170' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%232c6372' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%232b6573' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%23296774' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%23286975' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%23266b77' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%23256d78' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%23246f79' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%2322727a' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%2321747c' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%2320767d' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%231e797e' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%231d7c80' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%231b7e81' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%231c8083' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%231d8083' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%231f7f84' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%23217e85' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%23227e85' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%23247d86' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23267c87' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23287c87' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23297b88' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%232b7a88' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%232d7a88' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%232f7989' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%23317989' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%23337889' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%2335788a' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%2337778a' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%233a778a' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%233c768a' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%233e768a' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%2340758a' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%2343758a' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2345758a' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2347758a' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%234a758a' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%234c748a' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%234e748a' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%2351748a' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%2354758a' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%2356758a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23597589' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%235b7589' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%235e7689' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23617688' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23637788' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23667787' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525c' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c565f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5761' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234e5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234f5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%23505a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23515b66' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%2354606b' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355616c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356626d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636f' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6774' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235d6a76' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235e6b78' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235f6c79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%23606d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23616e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23626f7d' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647281' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657482' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%231a8182' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='0.79'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
.blue-bg {
  background: #4d5967;
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important;
  background-color: #4d5967;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 900'%3E%3Cg fill-opacity='0.08'%3E%3Cpath transform='rotate(0 636 600)' d='M1324 485c-81-58-192-40-282-73a722 722 0 0 1-319-252C652 68 562-56 429-39l-5 1a185 185 0 0 0-155 200c5 46 19 91 23 137 10 115-73 172-172 203-61 19-124 37-172 82-57 56-74 143-59 221a573 573 0 0 0 413 419c120 25 247 3 341-74 108-88 221-175 351-229 108-45 264-67 346-159 64-72 67-218-16-277z' fill='%23343c45'/%3E%3Cpath transform='rotate(0 1212 210)' d='M1864 416c-32-58-99-107-112-174-11-58 24-111 58-153 85-104 95-218 3-298s-202-83-261-110c-76-35-125-91-189-141-62-47-139-79-217-53-76 26-124 121-145 193-25 83 18 169-2 252-21 86-92 121-158 168-68 49-144 85-206 142-47 43-134 138-112 208 23 76 93 129 160 164 92 49 201 77 302 52 112-28 243-24 293 73 45 88 112 189 218 201a382 382 0 0 0 409-329c6-67-9-136-41-195z' fill='%231d2125'/%3E%3Cpath transform='rotate(0 420 165)' d='M887-281c-175-247-488-265-666-89C31-181-453 618 24 803c231 90 338-283 709-346 370-63 328-490 154-738z' fill='%23000'/%3E%3C/g%3E%3C/svg%3E");
  background-size: cover;
}
.black-glass-strong {
    background: rgba(18, 18, 20, 0.85);
    backdrop-filter: blur(24px);
    -webkit-backdrop-filter: blur(24px);
    border: 1px solid rgba(255, 255, 255, 0.18);
    /*box-shadow: 
        0 10px 40px rgba(0, 0, 0, 0.5),
        inset 0 2px 0 rgba(255, 255, 255, 0.2),
        inset 0 -2px 0 rgba(0, 0, 0, 0.3);
        */
    border-radius: 6px;
}
.leaderboard,
.podium-grid,
.overall-leaders,
.monthly-leader,
.lb-rows {
    overflow: visible !important;
}

.others-tooltip {
    z-index: 9999 !important;
    position: absolute !important;
}
/* ====================== PODIUM MOBILE FIX ====================== */

.podium-grid {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    gap: 24px;
    margin: 20px 0;
    width: 100%;
}

.podium-place {
    text-align: center;
    background: #4A5562;
    border-radius: 6px;
    padding: 24px 20px 20px;
    flex: 1;
    min-width: 0;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
    transition: all 0.25s ease;
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 250px;
}

.podium-place.first {
    transform: scale(1.08) translateY(-16px);
    box-shadow: 0 14px 32px rgba(0, 0, 0, 0.22);
    z-index: 1;
    min-height: 260px;
    padding-top: 32px;
}

/* ====================== MOBILE PODIUM (Stack Vertically) ====================== */
@media (max-width: 768px) {
    .podium-grid {
        flex-direction: column;
        align-items: center;
        gap: 16px;
    }

    .podium-place {
        flex: none;
        width: 100%;
        max-width: 380px;
        min-height: auto;
        padding: 20px 16px;
        transform: none !important;
        order: 2;                    /* default order */
    }

    .podium-place.first {
        order: 1;
        transform: none !important;
        min-height: auto;
        padding-top: 24px;
    }

    .podium-place.second {
        order: 2;
    }

    .podium-place.third {
        order: 3;
    }

    .podium-place .medal {
        font-size: 48px;
    }

    .podium-place .points {
        font-size: 24px;
    }

    .podium-place.first .points {
        font-size: 28px;
    }
}
@media (max-width: 768px) {
    .overall-leaders h3 {
        text-align: center;
        margin-bottom: 20px;
    }

    .podium-place {
        margin: 0 auto;
    }
}
/* ====================== MOBILE PODIUM (Stack + Same Width) ====================== */
@media (max-width: 768px) {
    .podium-grid {
        flex-direction: column;
        align-items: center;
        gap: 16px;
        padding: 0 16px;                    /* Match lb-rows padding */
    }

    .podium-place {
        flex: none;
        width: 100%;
        max-width: 100%;                    /* Full width like Phase 1 */
        min-height: auto;
        padding: 20px 16px;
        transform: none !important;
        order: 2;
        box-sizing: border-box;
    }

    .podium-place.first {
        order: 1;
        transform: none !important;
        padding-top: 24px;
    }

    .podium-place.second { order: 2; }
    .podium-place.third  { order: 3; }

    .podium-place .medal {
        font-size: 48px;
    }

    .podium-place .points {
        font-size: 24px;
    }

    .podium-place.first .points {
        font-size: 28px;
    }
}
</style>